import { FC, useRef, useMemo } from 'react'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { useShouldShowPageParamsStickyHeader } from 'helpers/pageHelpers'
import { PageParamsStickyHeader } from 'components/features/pfm/PageParamsHeader/PageParamsStickyHeader'
import { DesktopInternalStickyHeader } from 'components/features/pfm/DesktopInternalStickyHeader/DesktopInternalStickyHeader'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import { PageParamsHeader } from 'components/features/pfm/PageParamsHeader/PageParamsHeader'
import ModuleWrapper from 'components/features/pfm/ModuleWrapper/ModuleWrapper'
import TransactionsModuleContainer from 'components/features/pfm/TransactionsModule/TransactionsModuleContainer'
import { DEFAULT_TRANSACTIONS_SORTING } from 'constants/moneyflow'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import { TRANSACTIONS_PAGE } from 'constants/pages'
import { InternalPageRedirect } from 'components/features/pfm/InternalPageRedirect/InternalPageRedirect'
import Anchor from 'components/atoms/navigation/Anchor'

type TransactionsPageProps = {
}

export const TransactionsPage: FC<TransactionsPageProps> = (props) => {
  const {} = props

  const moduleChild = useMemo(() => (
    <ModuleWrapper
      title='Transactions'
      card={ false }
      anchor='spending_details'
    >
      <TransactionsModuleContainer type='transactions' defaultSorting={ DEFAULT_TRANSACTIONS_SORTING } />
    </ModuleWrapper>
  ), [])

  const staticHeaderRef = useRef<HTMLDivElement>(null)
  const shouldShowStickyHeader = useShouldShowPageParamsStickyHeader(staticHeaderRef)

  const notificationsChild = useMemo(() => (
    <NotificationTrayWrapper
      renderLevel='page'
      placement='spending_general'
      isPositionRelative
    />
  ), [])

  return (
    <InternalPageRedirect>
      <InternalLayoutContainer
        sidebar={ <InternalSidebarContainer /> }
        notifications={ notificationsChild }
        stickyHeader={ <PageParamsStickyHeader type={ TRANSACTIONS_PAGE } /> }
        shouldShowStickyHeader={ shouldShowStickyHeader }
      >
        <Anchor placement='transactions'>
          <DesktopInternalStickyHeader isShown={ shouldShowStickyHeader }>
            <PageParamsStickyHeader type={ TRANSACTIONS_PAGE } />
          </DesktopInternalStickyHeader>
          <SingleColumnLayout
            header={ <PageParamsHeader type={ TRANSACTIONS_PAGE } nodeRef={ staticHeaderRef } /> }
          >
            { moduleChild }
          </SingleColumnLayout>
        </Anchor>
      </InternalLayoutContainer>
    </InternalPageRedirect>
  )
}
